"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("../../hooks");

var _analytics = require("../../../modules/analytics");

var Page = function Page(props) {
  var _useClassNames = (0, _hooks.useClassNames)(props),
      className = _useClassNames.className,
      classNames = _useClassNames.classNames,
      children = _useClassNames.children,
      title = _useClassNames.title,
      id = _useClassNames.id,
      analytics = _useClassNames.analytics;

  var pageRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (title) {
      document.title = title;
    }

    if (id) {
      document.body.id = id;
      return function () {
        document.body.id = '';
      };
    }
  }, [id, title]);
  (0, _analytics.useAnalyticsEventScroll)({
    analytics: analytics,
    ref: pageRef
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: pageRef,
    className: (className + " " + classNames()).trim()
  }, children);
};

Page.propTypes = {
  /** It describes a standalone entity that is meaningful on its own. It will be used to generate the component className. */
  alias: _propTypes.default.string,

  /** The Page content. */
  children: _propTypes.default.node,

  /** The Page title, used as document title. */
  title: _propTypes.default.string,

  /** The Page id, used as body className and Page id. */
  id: _propTypes.default.string,

  /** Page analytics config. */
  analytics: _propTypes.default.shape({
    pagetype: _propTypes.default.string.isRequired
  })
};
Page.defaultProps = {
  alias: 'Page'
};
Page.displayName = 'Page';
var _default = Page;
exports.default = _default;